import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_insurance_entry_exp",
    stages: {
        eligible_for_insurance: 1,
        insurance_panel_rendered: 2,
        next_page_clicked: 3,
        confirmation_page_loaded: 4,
        eligible_mobile: 5,
        eligible_desktop: 6
    },
    defaultStage: 1,
    goals: {
        add_insurance_button_clicked: 1,
        do_not_add_insurance_button_clicked: 2,
        go_to_next_page_with_insurance: 3,
        insurance_attached_on_confirmation_page: 4
    }
});
export default utils;
